Vue.component('app-header', {
    mounted: function() {
        this.$root.$on('signIn', () => {
            this.currentUser = game.services.user.currentUser;
        });
    },
    data: function() {
        return {
            currentUser: null
        };
    },
    methods: {
        signIn: function() {
            this.$root.$emit('changeState', 'state-signin');
        },
        showProfile: function() {
            this.$root.$emit('changeState', 'state-profile');
        },
        showSettings: function(event) {
            event.preventDefault();
            this.$root.$emit('changeState', 'state-settings');
        }
    },
    template: `
    <div class="app-header">
        <div v-if="!currentUser" class="app-header-profile app-header-profile-signin" v-on:click="signIn()">
            <i class="fa fa-sign-in"></i> Sign In
        </div>
        <div v-if="currentUser" class="app-header-profile app-header-profile-signedin" v-on:click="showProfile()">
            <div class="vertical-center" style="padding:6px;">
                <img class="icon-sm" src="assets/rank_icon.png"><b>{{currentUser.currentRank}}</b> {{currentUser.name}}
            </div>
        </div>
        <img class="app-logo" src="assets/logo.png" alt="AntWar.io">
        <div class="app-header-left">
            <a href="https://discord.gg/ZwBuWu3GAp" target="_blank" style="padding:0;" class="app-social-button app-social-button-sm fa fa-discord">
                <img style="padding:0; margin-left:-3px; margin-top:-2px; width:40px;" src="assets/discord_small.svg">
            </a>
            <a href="https://www.reddit.com/r/antwar/" target="_blank" class="app-social-button app-social-button-sm fa fa-reddit"></a>
            <a href="https://twitter.com/bombsightgames" target="_blank" class="app-social-button app-social-button-sm fa fa-twitter"></a>
            <a href="#" class="app-social-button app-social-button-sm btn-settings" v-on:click="showSettings($event)"><i class="fa fa-gear"></i></a>
        </div>
    </div>
    `
})